export const emailFrequencies = {
  DISABLED: 'DISABLED',
  DAILY_DIGEST: 'DAILY_DIGEST',
  IMMEDIATE: 'IMMEDIATE',
};
